export const ARTICLE1_MENTORAT = 'ARTICLE1_MENTORAT';
export const VISIONS = 'VISIONS';
